import { render } from "./DiscountDetailModal.vue?vue&type=template&id=2048a5a8&scoped=true"
import script from "./DiscountDetailModal.vue?vue&type=script&lang=js"
export * from "./DiscountDetailModal.vue?vue&type=script&lang=js"

import "./DiscountDetailModal.vue?vue&type=style&index=0&id=2048a5a8&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2048a5a8"]])

export default __exports__